module.exports = __webpack_public_path__ + "img/3.bbb21dcf.jpg";